import selectWeekStartDayOption from '../data/mutators/selectWeekStartDayOption';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import dateTimeStrings from 'owa-strings/owa-datetime-strings';
import { observer } from 'mobx-react';
import getWeekStartDay from '../selectors/getWeekStartDay';

/**
 * Interface for week start day props
 */

interface WeekStartDayProps {
    saveWeekStartDayQuickSetting?: (dayOfWeek: number) => void;
    isQuick?: boolean;
}
export { WeekStartDayProps };

/**
 * The WeekStartDay parameter specifies the first day of the week. Valid values are:
 * Sunday (default value), Monday, Tuesday, Wednesday, Thursday, Friday, Saturday
 */
export default observer(function WeekStartDay({
    saveWeekStartDayQuickSetting,
    isQuick,
}: WeekStartDayProps) {
    const dayOfweekOptions = [
        { key: 0, text: dateTimeStrings.calendarDayOfWeek_Sunday },
        { key: 1, text: dateTimeStrings.calendarDayOfWeek_Monday },
        { key: 2, text: dateTimeStrings.calendarDayOfWeek_Tuesday },
        { key: 3, text: dateTimeStrings.calendarDayOfWeek_Wednesday },
        { key: 4, text: dateTimeStrings.calendarDayOfWeek_Thursday },
        { key: 5, text: dateTimeStrings.calendarDayOfWeek_Friday },
        { key: 6, text: dateTimeStrings.calendarDayOfWeek_Saturday },
    ];

    /**
     * Save directly in case of quick setting, otherwise set the value in store
     * @param option dayOfweekOptions item
     */
    const onWeekStartDayChange = (option: IDropdownOption) => {
        if (saveWeekStartDayQuickSetting) {
            saveWeekStartDayQuickSetting(option.key as number);
        } else {
            selectWeekStartDayOption(option.key as number);
        }
    };

    return (
        <Dropdown
            selectedKey={getWeekStartDay()}
            label={isQuick ? undefined : strings.options_appearance_weekstartdayLabel}
            ariaLabel={strings.options_appearance_weekstartdayLabel}
            options={dayOfweekOptions}
            onChanged={onWeekStartDayChange}
        />
    );
});
